<template>
    <div>

        <app-bar
                :backTo="back_to"
                hideMenu
        >
            <template v-if="this.user_id === null" v-slot:action>
                <v-file-input
                        style="flex:0"
                        hide-input
                        hide-details
                        prepend-icon="mdi-image-edit-outline"
                        v-model="files"
                        @change="handleFileUpload()"
                ></v-file-input>
            </template>

        </app-bar>

        <v-card tile v-if="member">
            <v-img :height="300" :src="member.picture.src">

                <template v-slot:placeholder>
                    <v-progress-linear color="black" height="2" indeterminate></v-progress-linear>
                </template>

                <v-app-bar flat color="rgba(0, 0, 0, .2)">
                    <v-toolbar-title class="title white--text pl-0 text-e">
                        <strong>Tag Name:</strong> {{member.name}}
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <!--<v-btn color="white" icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>-->
                </v-app-bar>

            </v-img>

            <div v-if="member.club" class="pb-0 mb-0 text-center negative-margin-top">
                <v-avatar color="#f7f7f7" size="130" class="elevation-8 border">
                    <v-img class="pa-2" :alt="member.club.name"
                           :src="member.club.logo">
                        <template v-slot:placeholder>
                            <v-progress-circular class="mt-12" width="2" indeterminate></v-progress-circular>
                        </template>
                    </v-img>
                </v-avatar>
                <h3 class="py-2">{{member.club.name}} {{member.club.length}}</h3>
            </div>

            <v-divider></v-divider>

            <v-list v-for="(item,i) in member.profile" :key="i">
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon color="deep-purple darken-1">{{item.icon}}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <h3>{{item.title}}</h3>
                        <p class="text-body-2">{{item.value}}</p>
                    </v-list-item-content>

                    <v-list-item-icon v-if="item.title === 'Email' || item.title === 'Telefono'">
                        <v-btn fab small outlined color="deep-purple darken-1" :href="action(item.value)">
                            <v-icon>mdi-arrow-right</v-icon>
                        </v-btn>
                    </v-list-item-icon>
                </v-list-item>
                <v-divider v-if="i != Object.keys(member.profile).pop()" inset></v-divider>
            </v-list>

        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default {
        name: "member",
        props: {
            user_id: {
                type: Number,
                default: null
            },
            back_to: Object
        },
        data: () => ({
            files: [],
            allLoaded: false,
            member: false
        }),
        computed: {
            ...mapState([
                'loggedIn',
                '_token'
            ]),
            ...mapGetters([
                'getMemberID',
                'getClubID',
                'getMainClubID',
                'isAdmin',
            ])
        },
        mounted() {
            setTimeout(() => {
                this.getMemberData();
            }, 100)
        },
        methods: {
            handleFileUpload() {
                if (this.files.type !== 'image/jpeg') {
                    alert('Formato errato!');
                    return;
                }
                this.setLoading(true);
                let formData = new FormData();
                formData.append('select_file', this.files);
                formData.append('container_id', this.getMemberID);
                formData.append('disk', 'public');
                formData.append('path', this.getMemberID + '/up');
                formData.append('target', 'up');

                axios.post(this.$store.state.ROOT_API + '/member/uploader',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((res) => {
                    if(!res.data.status){
                        alert(res.data.msg);
                        this.setLoading(false);
                        return false;
                    }
                    this.member.picture.src = res.data.path_img;
                    this.setLoading(false);
                }).catch((error) => {
                    console.error(error)
                })
            },
            getMemberData() {
                this.setLoading(true);
                this.allLoaded = false;
                axios
                    .post(this.$store.state.ROOT_API + '/member', {user_id: this.user_id}, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getToken
                        }
                    })
                    .then((res) => {
                        this.member = res.data;
                        //console.log(this.member);
                        this.setLoading(false);
                        this.allLoaded = true;
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            ...mapMutations([
                'setLoading'
            ]),
            action(value) {
                return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) ? 'mailto:' : 'callto:') + value;
            }
        }
    }
</script>

<style scoped>
    .negative-margin-top {
        margin-top: -80px !important
    }
</style>